<!-- todo - don't use anymore! use ElTooltip with element-plus or customize it with them! -->
<template>
  <component
    :is="containerTag"
    :class="[$style.wrapper, { disabled }]"
    data-type="tooltip"
  >
    <slot />

    <div
      v-if="$slots.message || message"
      :class="[
        $attrs.class,
        $style.tooltip,
        $style[`tooltip_${position}`],
        $style[`tooltip_${color}`],
      ]"
    >
      <slot name="message">
        <div v-html="message" />
      </slot>
    </div>
  </component>
</template>

<script setup lang="ts">
interface Props {
  containerTag?: string;
  position?: 'top' | 'right' | 'bottom' | 'left' | 'top-left';
  color?: 'primary' | 'secondary' | 'danger' | 'accent' | 'accent-second' | 'success-fill';
  disabled?: boolean;
  message?: string;
}

withDefaults(defineProps<Props>(), {
  containerTag: 'div',
  position: 'bottom',
  color: 'primary',
  disabled: false,
  message: '',
  align: '',
});
</script>

<style lang="scss" module>
@import "@/assets/style/variables.scss";
$box-shadow: 0 0 2px 0 rgba(black, 0.3);

@keyframes tooltipShowing {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.tooltip {
  background-color: $color-white;
  border-radius: 0.5rem;
  box-shadow: 0 6px 32px 0 #001C301F;
  color: black;
  display: inline-block;
  font-size: 13px;
  line-height: 0.8rem;
  max-width: calc(100vw - 2rem);
  opacity: 0;
  padding: 12px 16px;
  position: absolute;
  text-align: center;
  user-select: none;
  visibility: hidden;
  width: max-content;
  z-index: $tooltip-index;
  font-weight: 500;

  &::after {
    content: "";
    position: absolute;
    left: 9%;
    top: -38%;
    margin-left: 5px;
    border-width: 5px;
    border-style: solid;
    border-color: white transparent transparent transparent;
    transform: rotate(180deg) scale(2);
  }

  &_top {
    left: 50%;
    margin-top: 0.25rem;
    bottom: 106%;
    transform: translateX(-50%);

    &:before {
      content: "";
      display: block;
      position: absolute;
      width: 20px;
      height: 9px;
      left: 50%;
      bottom: 0;
      top: auto;
      transform: translateX(-50%);
      background: white;
      z-index: 1;
    }
    &::after {
      width: 12px;
      height: 12px;
      left: 50%;
      bottom: -6px;
      top: auto;
      margin-left: 0;
      transform: translateX(-50%) rotate(45deg);
      box-shadow: 1px 1px 3px -2px black;
      background: white;
    }
  }

  &_right {
    left: 100%;
    margin-left: 0.25rem;
    top: 50%;
    transform: translateY(-50%);
  }

  &_bottom {
    left: -5px;
    top: calc(100% + 10px);
  }

  &_left {
    margin-right: 0.25rem;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);

    &::after {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 14px 14px 0 0;
      border-color: white transparent transparent transparent;
      transform: translate(6px, -50%) rotate(135deg);
      right: 0;
      left: auto;
      margin-left: 0;
      top: 50%;
    }
  }

  &_top-left {
    bottom: 50%;
    right: 0;
    transform: translateY(-50%);
  }

  &_primary {
    border-color: $color-primary-dark;
  }

  &_secondary {
    border-color: $color-secondary-dark;
  }

  &_accent {
    border-color: $color-accent;
  }

  &_accent-second {
    border-color: $color-accent-second-dark;
  }

  &_danger {
    border-color: $color-danger-dark;
  }

  &_success-fill {
    color: white;
    background-color: $btn-bg-success_hover;
    border-color: $btn-bg-success_hover;
  }
}

.wrapper {
  display: inline;
  position: relative;

  &:hover > .tooltip {
    animation: tooltipShowing $transition-speed ease-in-out 1 forwards;
    animation-delay: $transition-speed * 2;
    visibility: visible;
  }

  &:global(.disabled) {
    pointer-events: none;
  }
}
</style>
